import React from "react";
import { Rate } from "antd";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";

const RateWrapper = styled.div({
  display: "flex",
  alignItems: "center",
  gap: "0.4rem",
});

const RateBox = styled(Rate)({
  fontFamily: "Pretendard, Sans-serif",

  "& .ant-rate-star": {
    marginRight: "0.2rem !important", // 원하는 간격으로 조절
  },
});

type Props = {
  rate: number;
  readonly?: boolean;
  color?: string;
  size?: string;
  reviewCnt?: number;
  onClick?: () => void;
  onChange?: (value: number) => void; // value의 타입을 명확히 지정
};

const StarRating = ({
  rate,
  readonly = false,
  color,
  size = "1.6rem",
  reviewCnt,
  onClick,
  onChange,
}: Props) => {
  const theme = useTheme();

  const handleRateChange = (value: number) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <RateWrapper onClick={onClick}>
      <RateBox
        disabled={readonly}
        // allowHalf
        style={{
          color: color || theme.color.orange,
          fontSize: size,
        }}
        value={rate}
        onChange={handleRateChange}
      />
      {reviewCnt !== undefined && <span>({reviewCnt})</span>}
    </RateWrapper>
  );
};

export default StarRating;
